export enum UserRole {
  project = "project",
  investor = "investor",
}
